import { memo, useState } from 'react';
import Dropdown from '../../../common/drop-down/DropDown';
import styles from './LeadTickets.module.scss';
import { SelectArrow } from '../../../common/all-icons/custom-icons';
import DropDownRenderBody from './DropDownRenderBody';
import { Flex } from 'antd';
import { Avatar } from '../../../common';

const ChangeAssigneeBody = ({
  data = {},
  isAllowed = false,
  fetchUsers = () => {},
  loader = false,
  users = [],
  onSuccess = () => {},
  changeFunc = () => {},
  type,
}) => {
  const [visible, onVisibleChange] = useState(false);
  const DropDownButton = memo(() => {
    return (
      <Flex
        className={`${styles.ticketButton} ${!data?.assignee?.name && styles.unassigned}`}
        onClick={() => fetchUsers()}
        align="center"
        gap={8}
      >
        {data?.assignee?.name ? (
          <>
            <Avatar size={32} src={data?.assignee?.profile_picture} isSystem={true} name={data?.assignee?.name} />
            <Flex vertical>
              <div className="body-12-medium">{data?.assignee?.name}</div>
              <div style={{ color: 'var(--user-main-text)' }} className="body-10-regular">
                {data?.assignee?.email}
              </div>
            </Flex>
          </>
        ) : (
          <div className="body-14-medium">Select Assignee</div>
        )}
        {isAllowed && (
          <SelectArrow
            style={{
              transform: 'rotate(-180deg)',
            }}
          />
        )}
      </Flex>
    );
  });

  if (!isAllowed) {
    return <DropDownButton />;
  }

  return (
    <Dropdown
      placement="bottomLeft"
      DropDownButton={DropDownButton}
      visible={visible}
      onVisibleChange={onVisibleChange}
      dropdownRender={() => (
        <DropDownRenderBody
          loader={loader}
          users={users}
          selectedData={data}
          changeFunc={changeFunc}
          onSuccessResolve={(data) => {
            onSuccess(data);
            fetchUsers(true);
          }}
          type={type}
        />
      )}
    />
  );
};

export default ChangeAssigneeBody;
